import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';

/**
 * @public
 */
export interface ILinkFieldProps {
  text: string | undefined;
  onClick: () => void;
}

/**
 * @public
 */
export const LinkField: React.StatelessComponent<ILinkFieldProps> = (props: ILinkFieldProps) => {
  return (
    <Link data-selection-invoke={ true } onClick={ props.onClick }>{ props.text || '' }</Link>
  );
};
